import { useEffect } from "react";
import { destinoNoAdmin } from "../../lib/admin-url";

/**
 * Rota `/admin/*` do CRM e do app do jogador: manda para o admin da PPS do
 * mesmo ambiente, preservando subcaminho e query (`lib/admin-url.ts`). Não
 * renderiza nada — o `replace` não deixa a rota velha no histórico.
 */
export function RedirecionaParaAdmin({ ambiente }: { ambiente: string | null | undefined }) {
  useEffect(() => {
    window.location.replace(destinoNoAdmin(ambiente, window.location.pathname, window.location.search));
  }, [ambiente]);
  return null;
}
